import { render, staticRenderFns } from "./customDashboardTable.vue?vue&type=template&id=36ba0dee&scoped=true"
import script from "./customDashboardTable.vue?vue&type=script&lang=js"
export * from "./customDashboardTable.vue?vue&type=script&lang=js"
import style0 from "./customDashboardTable.vue?vue&type=style&index=0&id=36ba0dee&prod&lang=scss&scoped=true"
import style1 from "./customDashboardTable.vue?vue&type=style&index=1&id=36ba0dee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ba0dee",
  null
  
)

export default component.exports